const customer_io_loader = () => {
  if (window._cio?.identify) return window._cio

  window._cio = window._cio || [];

  /* eslint-disable */
  (function() {
    var a,b,c;a=function(f){return function(){_cio.push([f].
    concat(Array.prototype.slice.call(arguments,0)))}};b=["identify",
    "track"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
    var t = document.createElement("script"),
        s = document.getElementsByTagName("script")[0];
    t.async = true;
    t.id    = "cio-tracker";
    t.setAttribute("data-site-id", window.gon.customerio_token);
    // https://customer.io/docs/javascript-quick-start/#event-array-data
    t.setAttribute("data-use-array-params", "true");
    t.src = "https://assets.customer.io/assets/track.js";
    s.parentNode.insertBefore(t, s);
  })();
  /* eslint-enable */
  return window._cio
}

if (window.gon.current_user) customer_io_loader()

export default customer_io_loader
